/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Form } from "antd";
import { fetchPaymentsByAggId, resetPaymentsAccount } from "../../store/slices/payments";
import AccountPayments from "../../components/AccountPayments/AccountPayments";
import { fetchGetAgreementsByAccId } from "../../store/slices/agreements";
import {
  fetchPaymentSourceTypes,
  fetchPaymentStatuses,
  fetchCurrenciesDic,
} from "../../store/slices/rtkDictionaries";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

const AccountPaymentsContainer = () => {
  const paymentsSearchParams = {
    // page: 0,
    // size: 10,
    datePay: [],
    dateConfirm: [],
    paymentDateFrom: "",
    paymentDateTo: "",
    confirmDateFrom: "",
    confirmDateTo: "",
    amount: "",
    unpaged: true,
    includePaymentStatusIds: [2],
  };

  const { accountId } = useParams();
  const { agreements, agreementsLoading } = useSelector((state) => state.agreements);
  const { dicAdjustmentTypeLoading } = useSelector((state) => state.rtkDictionaries);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (accountId) {
      dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
    }
    dispatch(fetchPaymentStatuses());
    dispatch(fetchPaymentSourceTypes());
    dispatch(fetchCurrenciesDic());
  }, []);

  // Очистка по выходу
  useEffect(
    () => () => {
      dispatch(resetPaymentsAccount());
    },
    []
  );

  const fetchPayments = (values) => {
    const aggArray = new Set();
    if (checkIsLoaded(agreementsLoading)) {
      agreements.forEach((item) => {
        aggArray.add(item.id);
      });
    }
    if (agreements.length !== 0) {
      dispatch(fetchPaymentsByAggId({ agreementId: [...aggArray], paymentsSearchParams: values }));
    }
  };

  useEffect(() => {
    fetchPayments(paymentsSearchParams);
  }, [agreements[0]?.id]);

  const resetSearchPayments = () => {
    form.setFieldsValue({
      // page: 0,
      // size: 10,
      datePay: [],
      dateConfirm: [],
      paymentDateFrom: "",
      paymentDateTo: "",
      confirmDateFrom: "",
      confirmDateTo: "",
      amount: "",
      unpaged: true,
      paymentIds: "",
      includePaymentStatusIds: [2],
    });
    fetchPayments(paymentsSearchParams);
  };

  return (
    <AccountPayments
      agreements={agreements}
      paymentsSearchParams={paymentsSearchParams}
      resetSearchPayments={resetSearchPayments}
      fetchPayments={fetchPayments}
      form={form}
    />
  );
};

export default AccountPaymentsContainer;
